export default __webpack_public_path__ + "static/O0079-2af9823e8e44e3e0bd37c3f4ebf13861.png";